import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { func } from 'prop-types'
import { stores, view } from '../../stores'

class AvanceImmediateDetailsComponent extends Component {
  render () {
    const { t } = this.props
    const infos = stores.avanceImmediate.infos
    return (
      <div>
        <p> {t('common:avance_immediate:infos:intro_text_1')} </p>
        <p> {t('common:avance_immediate:infos:intro_text_2')} </p>
        <p> {t('common:avance_immediate:infos:intro_text_3')} </p>
        <p> {t('common:avance_immediate:infos:intro_text_4')} </p>
        {infos.usesAvanceImmediate
          ? <div>
            <p> {t('common:avance_immediate:infos:text_enabled')} </p>
            <button
              style={{ marginTop: '30px' }}
              onClick={() => this.changeUsageAvanceImmediate(false)}
              className='btn--green layout--centered'>{t('common:avance_immediate:infos:button_disable')}</button>
          </div>
          : <div>
            <p> {t('common:avance_immediate:infos:text_disabled')} </p>
            <button
              style={{ marginTop: '30px' }}
              onClick={() => this.changeUsageAvanceImmediate(true)}
              className='btn--green layout--centered'>{t('common:avance_immediate:infos:button_enable')}</button>
          </div>
        }
      </div>
    )
  }

  async changeUsageAvanceImmediate (enable) {
    await stores.avanceImmediate.changeUsageAvanceImmediate(enable)
  }
}

AvanceImmediateDetailsComponent.propTypes = {
  t: func
}

export const AvanceImmediateDetails = translate()(view(AvanceImmediateDetailsComponent))



// WEBPACK FOOTER //
// ./src/components/customer/AvanceImmediateDetails.js